// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3SvNG","title":"Header_title__3GJT_","left":"Header_left__lRGV0","clinicName":"Header_clinicName__1cHIL"};